import React from 'react';
import { Mail, Globe, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="py-8 px-4 bg-slate-900 text-white border-t border-white/5" data-id="element-71" data-mp="3gezf99jl213s">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-72" data-mp="32nulgo2wc31d">
        <div className="mb-8" data-id="element-73" data-mp="32lrmhejrmzki">
          <span className="text-blue-400 font-black tracking-widest text-sm uppercase" data-id="element-74" data-mp="36p6aoshuym91">
            GUIADIGITAL360 TM
          </span>
          <p className="text-slate-400 text-xs mt-2 font-bold uppercase tracking-tighter" data-id="element-75" data-mp="3ugbqj7nstejc">
            Química Visual © {new Date().getFullYear()}
          </p>
        </div>

        <div className="flex gap-6 mb-8" data-id="element-76" data-mp="3lf582t1l9tng">
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-77" data-mp="3le2jwsvni5b8">
            <Instagram size={20} data-id="element-78" data-mp="3qbvmlbxqwh6r" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-79" data-mp="29zgkq0kfasm4">
            <Mail size={20} data-id="element-80" data-mp="2a1ji55nwno0v" />
          </a>
          <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-81" data-mp="2ezbb830adg6n">
            <Globe size={20} data-id="element-82" data-mp="3l90ozzfy550u" />
          </a>
        </div>

        <div className="space-y-2 text-[10px] md:text-xs text-slate-500 font-medium max-w-md" data-id="element-83" data-mp="3lbmw5xyxdiij">
          <p data-id="element-84" data-mp="3gck0v58qyqnr">
            Descargo de responsabilidad: Los resultados pueden variar según cada
            docente, contexto institucional y modalidad de uso. El material es
            de carácter pedagógico y didáctico.
          </p>
        </div>
      </div>
    </footer>;
}